import VoteMixin from './vote';
import DataMixin from './data';
import ManagerMixin from './manager';
import UserMixin from './user';
import DevMixin from './dev';

export default [
	VoteMixin,
	DataMixin,
	ManagerMixin,
	UserMixin,
	DevMixin
];